/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import { LotteryPreferenceProps, LotteryPreferencePickerProps } from './Lottery';

export const HuntingLotteryApplicationProps = PropTypes.shape({
    id: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    extra_fields: PropTypes.shape({
        lottery_preferences: PropTypes.arrayOf(
            PropTypes.oneOf([LotteryPreferencePickerProps, LotteryPreferenceProps])
        ),
    }),
});
